import { useMemo, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import PageTabs from "../components/PageTabs";
import {
  LearnerReportDownloadsContent,
} from "./LearnerReportDownloads";
import {
  UpdateUserCourseCompletionContent,
} from "./UpdateUserCourseCompletion";
import { LearnerTableContent } from "./LearnerTable";
import { useAuth } from "../utils/hooks/useAuth";
import { hasFullLearnerAccess } from "../utils/roles";
import { LearnerMobileNumberUpdateContent } from "./AdminSettingsSections";

type LearnerTab = "reports" | "table" | "status-updation" | "mobile-update";

export default function LearnerPage() {
  const { role } = useAuth();
  const canManageLearners = hasFullLearnerAccess(role);
  const [activeTab, setActiveTab] = useState<LearnerTab>("reports");

  const tabs = useMemo(
    () =>
      [
        { id: "reports", label: "Reports" },
        { id: "table", label: "Learner Table" },
        canManageLearners
          ? { id: "status-updation", label: "Status Updation" }
          : null,
        canManageLearners
          ? { id: "mobile-update", label: "Mobile Update" }
          : null,
      ].filter(Boolean) as { id: LearnerTab; label: string }[],
    [canManageLearners],
  );

  return (
    <AdminLayout title="Learner">
      <div className="max-w-6xl flex flex-col gap-6">
        <div className="bg-white border border-gray-200 rounded-xl px-6 shadow-sm">
          <PageTabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={(tabId) => setActiveTab(tabId as LearnerTab)}
          />
        </div>

        {activeTab === "reports" && <LearnerReportDownloadsContent />}
        {activeTab === "table" && <LearnerTableContent />}
        {activeTab === "status-updation" && canManageLearners && (
          <UpdateUserCourseCompletionContent />
        )}
        {activeTab === "mobile-update" && canManageLearners && (
          <LearnerMobileNumberUpdateContent />
        )}
      </div>
    </AdminLayout>
  );
}
